import React from 'react';

// Opens the student-facing section preview (shared_section_path) in a new tab — the same page the
// section edit page's "Save & Preview" lands on. Href pre-built by the parent (program context).
const SectionPreviewLink = ({ href }: { href: string }) => (
  <a
    aria-label="Preview this section (opens in a new tab)"
    className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-spa-accent-text tw-no-underline
      hover:tw-text-spa-accent-text-hover hover:tw-underline"
    href={href}
    rel="noopener noreferrer"
    target="_blank"
  >
    Preview section
  </a>
);

export default SectionPreviewLink;
